<div class="card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>{{ 'My Currencies' | translate }}</h5>
    </div>
  </div>
  <div class="card-body pt-0">
    <div class="recent-table table-responsive currency-table">
      <table class="table">
        <thead>
          <tr>
            <th class="f-light">{{ 'Coin Name' | translate }}</th>
            <th class="f-light">{{ 'Price' | translate }}</th>
            <th class="f-light">{{ '24h Change' | translate }}</th>
            <th class="f-light">{{ 'Total Balance' | translate }}</th>
            <th class="f-light">{{ 'Total Coin' | translate }}</th>
            <th class="f-light">{{ 'Action' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of currencies">
            <td>
              <div class="d-flex align-items-center gap-2">
                <div class="currency-icon {{ item.colorClass }}">
                  <svg>
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ item.icon }}"></use>
                  </svg>
                </div>
                <div>
                  <h6 class="f-14 mb-0 f-w-400">{{ item.currenciesName }}</h6>
                </div>
              </div>
            </td>
            <td>${{ item.price }}</td>
            <td>
              <div class="change-currency" [ngClass]="item.arrow === 'trending-up' ? 'font-success' : 'font-secondary'">
                <i class="me-1">
                  <app-feather-icons [icon]="item.arrow"></app-feather-icons> </i
                >{{ item.growth }}
              </div>
            </td>
            <td>${{ item.totalBalance }}</td>
            <td>{{ item.totalCoin }}</td>
            <td>
              <button class="btn badge-light-primary">{{ 'Trade' | translate }}</button>
            </td>
          </tr>

          <!-- <tr> 
             <td>
               <div class="d-flex align-items-center gap-2">
                 <div class="currency-icon success">
                   <svg>
                     <use href="assets/svg/icon-sprite.svg#ltc"></use>
                   </svg>
                 </div>
                 <div> 
                   <h6 class="f-14 mb-0 f-w-400">{{ 'Litecoin' | translate }}</h6>
                 </div>
               </div>
             </td>
             <td>{{ '$11,098.04' | translate }}</td>
             <td>
               <div class="change-currency font-secondary"><i class="me-1" data-feather="trending-down"></i>{{ '2.90' | translate }}</div>
             </td>
             <td>{{ '$87,897.098' | translate }}</td>
             <td>{{ '1.09675432' | translate }}</td>
             <td> 
               <button class="btn badge-light-primary">{{ 'Trade' | translate }}</button>
             </td>
           </tr>
           <tr> 
             <td>
               <div class="d-flex align-items-center gap-2">
                 <div class="currency-icon primary">
                   <svg>
                     <use href="assets/svg/icon-sprite.svg#eth"></use>
                   </svg>
                 </div>
                 <div> 
                   <h6 class="f-14 mb-0 f-w-400">{{ 'Eathereum' | translate }}</h6>
                 </div>
               </div>
             </td>
             <td>{{ '$45,198.09' | translate }}</td>
             <td>
               <div class="change-currency font-success"><i class="me-1" data-feather="trending-up"></i>{{ '0.12' | translate }}</div>
             </td>
             <td>{{ '$45,178.010' | translate }}</td>
             <td>{{ '1.41557127' | translate }}</td>
             <td> 
               <button class="btn badge-light-primary">{{ 'Trade' | translate }}</button>
             </td>
           </tr>
           <tr> 
             <td>
               <div class="d-flex align-items-center gap-2">
                 <div class="currency-icon secondary">
                   <svg>
                     <use href="assets/svg/icon-sprite.svg#bin"></use>
                   </svg>
                 </div>
                 <div> 
                   <h6 class="f-14 mb-0 f-w-400">{{ 'Binance' | translate }}</h6>
                 </div>
               </div>
             </td>
             <td>{{ '$35,098.34' | translate }}</td>
             <td>
               <div class="change-currency font-success"><i class="me-1" data-feather="trending-up"></i>{{ '3.56' | translate }}</div>
             </td>
             <td>{{ '$64,100.066' | translate }}</td>
             <td>{{ '1.78142254' | translate }}</td>
             <td> 
               <button class="btn badge-light-primary">{{ 'Trade' | translate }}</button>
             </td>
           </tr>
           <tr> 
             <td>
               <div class="d-flex align-items-center gap-2">
                 <div class="currency-icon dark-green">
                   <svg>
                     <use href="assets/svg/icon-sprite.svg#te"></use>
                   </svg>
                 </div>
                 <div> 
                   <h6 class="f-14 mb-0 f-w-400">{{ 'Tether' | translate }}</h6>
                 </div>
               </div>
             </td>
             <td>{{ '$56,898.91' | translate }}</td>
             <td>
               <div class="change-currency font-secondary"><i class="me-1" data-feather="trending-down"></i>{{ '1.23' | translate }}</div>
             </td>
             <td>{{ '$61,574.218' | translate }}</td>
             <td>{{ '1.574215' | translate }}</td>
             <td> 
               <button class="btn badge-light-primary">{{ 'Trade' | translate }}</button>
             </td>
           </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</div>
